import { fetcher } from '@commenda/utils';
import { ICommendaProduct, ProductsBulkUpdateProps } from './types';

export type UpdateSalesTaxProductsProps = {
  id?: string;
  name?: string;
  tax_code?: string;
  sku?: string;
  description?: string;
};

type ProductResult = {
  success: boolean;
  data?: ICommendaProduct;
  error?: string;
};

type BulkProductResult = {
  success: boolean;
  message?: string;
  error?: string;
};

export async function updateSalesTaxProduct(
  body: UpdateSalesTaxProductsProps,
  token: string,
  productId: string,
  corporationId: number
): Promise<ProductResult> {
  try {
    const response = await fetcher(
      `new-sales-tax/products/${productId}/corporation/${corporationId}`,
      { method: 'POST', body },
      token
    );

    if (!response.ok) {
      const errorData = await response.json();
      console.error('Error updating product:', errorData);
      return {
        success: false,
        error: errorData.message || 'Failed to update product',
      };
    }

    const data = await response.json();
    return {
      success: true,
      data,
    };
  } catch (error) {
    const errorMessage =
      error instanceof Error ? error.message : 'Failed to update product';
    console.error('Failed to update product:', error);
    return {
      success: false,
      error: errorMessage,
    };
  }
}

export async function bulkUpdateSalesTaxProducts(
  body: ProductsBulkUpdateProps,
  token: string
): Promise<BulkProductResult> {
  try {
    const response = await fetcher(
      'new-sales-tax/products/bulk/update',
      { method: 'POST', body },
      token
    );

    if (!response.ok) {
      return {
        success: false,
        error: 'Failed to bulk update products',
      };
    }

    const data = await response.json();
    return {
      success: true,
      message: data.message || 'Products updated successfully',
    };
  } catch (error) {
    const errorMessage =
      error instanceof Error ? error.message : 'Failed to bulk update products';
    return {
      success: false,
      error: errorMessage,
    };
  }
}